import { AccountingProvider, PayrollProvider, TicketingProvider } from '@neo.tax/shared/graphql';

import {
  AdpRunLogoStyled,
  AdpWorkforceNowLogoStyled,
  CeridianDayforceLogoStyled,
  GustoLogoStyled,
  JustworksLogoStyled,
  PaychexLogoStyled,
  PaylocityLogoStyled,
  QuickbooksLogoStyled,
  RipplingLogoStyled,
  TrinetLogoStyled,
  ZenefitsLogoStyled,
  NetsuiteLogoStyled,
  CsvLogoStyled,
  AsanaLogoStyled,
  JiraLogoStyled,
  JiraDataCenterLogoStyled,
  LinearLogoStyled,
  TrelloLogoStyled,
  GitHubLogoStyled,
  ShortcutLogoStyled,
  WorkdayLogoStyled,
} from './provider-logo.styled';
import { LogoType } from './provider-logo.types';

export const ACCOUNTING_PROVIDER_LOGOS: Record<AccountingProvider, LogoType> = {
  [AccountingProvider.Quickbooks]: QuickbooksLogoStyled,
  [AccountingProvider.Netsuite]: NetsuiteLogoStyled,
  [AccountingProvider.SelfReported]: CsvLogoStyled,
};

export const PAYROLL_PROVIDER_LOGOS: Record<PayrollProvider, LogoType> = {
  [PayrollProvider.AdpRun]: AdpRunLogoStyled,
  [PayrollProvider.AdpWorkforceNow]: AdpWorkforceNowLogoStyled,
  [PayrollProvider.CeridianDayforce]: CeridianDayforceLogoStyled,
  [PayrollProvider.Gusto]: GustoLogoStyled,
  [PayrollProvider.Justworks]: JustworksLogoStyled,
  [PayrollProvider.PaychexFlex]: PaychexLogoStyled,
  [PayrollProvider.Paylocity]: PaylocityLogoStyled,
  [PayrollProvider.Quickbooks]: QuickbooksLogoStyled,
  [PayrollProvider.Rippling]: RipplingLogoStyled,
  [PayrollProvider.SelfReported]: CsvLogoStyled,
  [PayrollProvider.Trinet]: TrinetLogoStyled,
  [PayrollProvider.Workday]: WorkdayLogoStyled,
  [PayrollProvider.Zenefits]: ZenefitsLogoStyled,
};

export const TICKETING_PROVIDER_LOGOS: Record<TicketingProvider, LogoType> = {
  [TicketingProvider.Asana]: AsanaLogoStyled,
  // add a real logo if you want to connect to azure
  [TicketingProvider.AzureDevops]: CsvLogoStyled,
  [TicketingProvider.JiraCloud]: JiraLogoStyled,
  [TicketingProvider.JiraDataCenter]: JiraDataCenterLogoStyled,
  [TicketingProvider.Linear]: LinearLogoStyled,
  [TicketingProvider.Trello]: TrelloLogoStyled,
  [TicketingProvider.GithubIssues]: GitHubLogoStyled,
  [TicketingProvider.Shortcut]: ShortcutLogoStyled,
};
